<template>
  <b-navbar-nav>
    <b-nav-item :to="{name: 'register'}">Registrieren</b-nav-item>
    <b-nav-item :to="{name: 'login'}">Login</b-nav-item>
    <b-nav-item :to="{name: 'imprint'}">Impressum</b-nav-item>
  </b-navbar-nav>
</template>

<script>

export default {
  name: 'NavbarGuests'
}
</script>



// WEBPACK FOOTER //
// src/components/navbar/Guests.vue